// import router from "@/router";
import parseQueryString from 'outils/parseQueryString'
import request from "assets/js/request";
import TAIKO_API from "assets/js/interface";
import { timeFormat } from 'assets/js/tool'

const state = {
  code: "",
  qrCode: {
    img: '',
    expireTime: ''
  },
  serviceCode: ''
};

const getters = {
  code: state => state.code,
  qrCode: state => state.qrCode,
  serviceCode: state => state.serviceCode,
};

const mutations = {
  reqGetWxCode: async (state) => {
    if (!state.code) {
      const query = parseQueryString(location.search)
      // console.log(query);
      if (query.code) {
        state.code = query.code
        console.log('stateCode获取成功', state.code)
        // mutations.reqGetWxCode(state)
      } else {
        const appid = 'wx61accf0f0cf53d25'
        const redirect_uri = 'http://tak-test.wahlap.net/dist/'
        const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&connect_redirect=1#wechat_redirect`
        window.location.href = wechatAuthUrl
        // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx61accf0f0cf53d25&redirect_uri=http://tak-test.wahlap.net/api/info/tk/get_qr_code/&response_type=code&scope=snsapi_base#wechat_redirect
        // https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx61accf0f0cf53d25&redirect_uri=http://tak-test.wahlap.net/dist/&response_type=code&scope=snsapi_base#wechat_redirect
      }
    }
  },

  //获取登陆二维码
  reqGetQRCode: async (state) => {
    if (state.code) {
      const requestData = () => request.get(TAIKO_API.getQrCode, { code: state.code });
      const resData = await requestData();
      if (resData.ok) {
        if (typeof (resData.data) === 'string') {
          const data = JSON.parse(resData.data)
          // console.log(data)
          state.qrCode.img = data.imgPath
          // 自算到期时间
          let timestamp = Date.parse(new Date()) + 600000
          state.qrCode.expireTime = timeFormat(timestamp)
        }
      }
    }
  },
  //获取客服咨询二维码
  reqGetServiceCode: async (state) => {
    if (state.code) {
      const requestData = () => request.get(TAIKO_API.getInquiryCode, { code: state.code });
      const resData = await requestData();
      if (resData.ok) {
        if (typeof (resData.data) === 'string') {
          const data = JSON.parse(resData.data)
          // console.log(data)
          state.serviceCode = data.inquiryCode
        }
      }
    }
  }

};

const actions = {
  actionReqGetCode({ commit }, data) {
    commit("reqGetWxCode", data);
  },
  actionReqQRCodeImg({ commit }, data) {
    commit("reqGetQRCode", data);
  },
  actionReqServiceCodeImg({ commit }, data) {
    commit("reqGetServiceCode", data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
